<app-back-button></app-back-button>

<div class="ob-grid detail-view-header">
	<div class="ob-span-8 detail-view-header-title">
		<h1><ng-content select="detail-view-title"></ng-content></h1>
		<div class="detail-view-header-chip">
			<mat-chip-set
				><mat-chip>{{ "i18n.enum.catalog_type." + viewType.toLowerCase() | translate }}</mat-chip></mat-chip-set
			>
		</div>
	</div>
	<div class="ob-span-4 detail-view-header-actions">
		<ng-content select="detail-view-actions"></ng-content>
	</div>
</div>

<div class="detail-view-status">
	<h2 class="sr-only">{{ "i18n.status.title.text" | translate }}</h2>
	<ng-content select="detail-view-status"></ng-content>
</div>

<div class="detail-view-tabs">
	<h2 class="sr-only">{{ "i18n.tab_nav_bar.title.text" | translate }}</h2>
	<nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
		@for (tab of tabs; track tab) {
		<a mat-tab-link [routerLink]="tab" routerLinkActive="active" [id]="tabIdPrefix + tab">
			{{ "i18n.tab_nav_bar.tabs." + tab | translate }}
		</a>
		}
		<div mat-tab-link></div>
	</nav>
	<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>

<div class="detail-view-content">
	<router-outlet></router-outlet>
</div>
